// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-insight-data-source__content,.ac-insight-submission-details__content{padding:1.5rem 2rem}.ac-insight-submission-details__list{align-items:center;display:flex}.ac-insight-submission-details__list-item:not(:first-child):before{content:\"\\2022\";padding-left:1.5rem;padding-right:1.5rem}\n", ""]);
// Exports
module.exports = exports;
